import { CarouselApi } from '@wellesley/ui'
import { useCallback } from 'react'
import useEventListener from 'hooks/useEventListener'

type HookProps = {
  api: CarouselApi
  canNavigate: boolean
}

export const useKeyboardNavigation = ({ api, canNavigate }: HookProps) => {
  const onKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (!api || !canNavigate) return

      if (event.key === 'ArrowLeft') {
        api.scrollPrev()
      } else if (event.key === 'ArrowRight') {
        api.scrollNext()
      }
    },
    [api, canNavigate],
  )

  useEventListener('keydown', onKeyDown, document)
}
